import React from 'react';
import { connect } from 'react-redux';
import _get from 'lodash/get';
import { shouldForceContentstackPreview } from 'yoda-site-components/lib/cms-renderer/utils/previewContext';
import Iris from './Iris';
import Contentstack from './Contentstack';

// Homepage serves the single /home route. Contentstack is driven by the master
// flag; the live-preview iframe forces Contentstack so authors can preview CS
// content even while prod still serves IRIS (flag off).
function Home(props) {
    const { enableContentstackCMS, isPreview, enableLivePreview } = props;
    const forceContentstack = shouldForceContentstackPreview(isPreview, enableLivePreview);
    return enableContentstackCMS || forceContentstack ? (
        <Contentstack {...props} />
    ) : (
        <Iris {...props} />
    );
}

const mapStateToProps = ({ context }) => {
    const featureFlags = _get(context, 'featureFlags', {});

    return {
        enableContentstackCMS: featureFlags.enableContentstackCMS || false,
        enableLivePreview: featureFlags.enableLivePreview || false,
        isPreview: _get(context, 'isPreview', false),
    };
};

export default connect(mapStateToProps)(Home);
